import OwLabel from "../OwLabel/OwLabel";
import "./OwPill.scss";

type Props = {
    title: string;
    skipTranslate?: boolean;
    className?: string;
    labelClassName?: string;
    leftIconClass?: string;
};

export const OwPill = (props: Props) => {
    return (
        <div className={"OwPill " + props.className}>
            {props.leftIconClass ? <i role={'left-icon'} className={props.leftIconClass + " me-2"} /> : null}
            {props.skipTranslate ? (
                props.title
            ) : (
                <OwLabel className={props.labelClassName} title={props.title} noBottomMargin={true} />
            )}
        </div>
    );
}

export default OwPill;
